import axios from "axios";

const BASE_URL = process.env.VUE_APP_API_BASE_URL || "https://express-server-gules-mu.vercel.app";

// Funzione per recuperare tutti i piatti
export async function fetchAllDishes() {
    try {
        const response = await axios.get(`${BASE_URL}/dishes`);
        return response.data;
    } catch (error) {
        console.error('Error fetching dishes:', error);
        return [];
    }
}

// Funzione per recuperare un piatto per ID
export async function fetchDishById(dishId) {
    try {
        const response = await axios.get(`${BASE_URL}/dishes/${dishId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching dish with ID ${dishId}:`, error);
        return null;
    }
}

// Funzione per creare un nuovo piatto
export async function createDish(newDishData) {
    try {
        const response = await axios.post(`${BASE_URL}/dishes`, newDishData);
        return response.data;
    } catch (error) {
        console.error('Error creating new dish:', error);
        return null;
    }
}

// Funzione per aggiornare un piatto
export async function updateDish(dishId, updatedDishData) {
    try {
        const response = await axios.put(`${BASE_URL}/dishes/${dishId}`, updatedDishData);
        return response.data;
    } catch (error) {
        console.error(`Error updating dish with ID ${dishId}:`, error);
        return null;
    }
}

// Funzione per eliminare un piatto
export async function deleteDish(dishId) {
    try {
        const response = await axios.delete(`${BASE_URL}/dishes/${dishId}`);
        return response.status === 200;
    } catch (error) {
        console.error(`Error deleting dish with ID ${dishId}:`, error);
        return false;
    }
}

// Funzione per recuperare i piatti di una categoria
export async function fetchDishesByCategory(category) {
    try {
        const response = await axios.get(`${BASE_URL}/dishes/category/${category}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching dishes for category ${category}:`, error);
        return [];
    }
}

